module.exports = __webpack_public_path__ + "static/media/nima_play_jhali.225eace4.png";